import { Directive, ElementRef, HostListener, input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[libAutoLowercase]',
    standalone: false
})
export class AutoLowercaseDirective {
  libAutoLowercase = input(false);

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private control: NgControl) { }

  @HostListener('blur', ['$event'])
  onBlur(e: FocusEvent | Event): void {
    if (this.libAutoLowercase()) {
      this.control.control?.setValue(this.control.value.toLowerCase());
    }
  }
}
